<template>
    <Card id="mycard2">
      <template #title>CFDIS Ingresos vs Egresos <span>{{aYear}}</span>
        
        
        <Dropdown
            v-model="aYear"
            :options="ejercicios"
            id="comboejercicio"
            style="width: 100px"
            class="ml-2"
            @change="onSelectYear()"
        />
      </template>
      <template #content>
        <div id="mychart2" ref="chartline1"></div>
        
      </template>
    </Card>
</template>

<script>
    //import * as bb from 'billboard.js';
      
    import {
      definiciones
    } from "@/icontaelibs.js";

    import bb, { bar } from "billboard.js";
    import * as d3 from 'd3'; // billboard.js depends on D3.js
    import 'billboard.js/dist/billboard.css'; // Import default styles

    export default {
      name: "Chartdisponible",
      props: {
        gYear: String,
        gEjercicios : Array,
        
      },
      data() {
        return {
          chartline1: null,
         
          ejercicios:this.gEjercicios,
          aYear: this.gYear,
          empresaid: 0,
          tdoc:'Emitidos',
          itemsEmitidosRecibidos:["Emitidos", "Recibidos"],
          columnsdata : [
            ["x", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            ["data1", "0","0","0","0","0","0","0","0","0","0","0","0"],
            ["data2", 0,0,0,0,0,0,0,0,0,0,0,0],
            ["data3", 0,0,0,0,0,0,0,0,0,0,0,0]
          ],
          

          isLoading : false,
        };
      },
      mounted() {

      if (this.$store.getters.isEmpresa) {
        this.empresaid = this.$store.getters.dataEmpresa.data.id;
      }

       const d = new Date();
       this.aYear = d.getFullYear();
       console.log('--->char mounted<---');
       console.log('---><---'+this.aYear);
       this.getDataChart1();
        
        
      },
      
    
      beforeUnmount() {
        if (this.chartline1) {
          this.chartline1.destroy(); // Clean up billboard.js instance
        }
      },

      watch: {

        
        
        gEjercicios(){
           this.ejercicios = this.gEjercicios; 
        },
        /*gYear(){
           this.aYear = this.gYear; 
        }*/

        

      },

      methods: {



        setDetalleIngresosEgresos(data){

                
                console.log(data.id); 
                console.log(data.index);
                const routeData = this.$router.resolve({name: 'Chartdetalle', query: {dataid: data.id, dataindex:data.index}});
                window.open(
                  routeData.href,
                  "_blank",
                  "width=900,height=800,left=100,top=50"
                );

        },
       
        onSelectYear(){

          this.getDataChart1();
        },



        getDataChart1() {
          console.log('char this.empresaid......');
          console.log(this.empresaid);
          
          this.isLoading = true;
          if (this.empresaid>0){
            this.$axios
            .get(
                definiciones.URL_API+"/chartsingresos1?p=1&ayear=" +this.aYear+"&tdoc="+this.tdoc+
                "&emp=" +this.empresaid
            )
            .then((response) => {

              console.log('chart - response.................');
              console.log(response.data);
              this.columnsdata = response.data;
              this.generateChart();
              this.isLoading = false;
              
            });
          }
          
          
        },

        generateChart() {
          console.log('char datos....');
        
          console.log(this.columnsdata[0]);
           console.log(this.columnsdata[1]);
            console.log(this.columnsdata[2]);
             console.log(this.columnsdata[3]);
          // Ensure D3 is available before generating the chart
          if (typeof d3 === 'undefined') {
            console.error('D3.js is not loaded. Please ensure it\'s imported correctly.');
            return;
          }

          
          this.chartline1 = bb.generate({
              
            data: {
               
                x: "x",
                columns: [this.columnsdata[0], this.columnsdata[1], this.columnsdata[2], this.columnsdata[3]],
                groups: [
                      [
                        "data1",
                        "data2"
                      ]
                    ],
                type: bar(), // for ESM specify as: bar()
                labels: true,
                onclick: (d) => {
                  console.log("Clicked bar:", d);
                  console.log("You clicked on: " + d.name + " with value: " + d.value);
                  //this.setDetalleIngresosEgresos(d);
                },
                colors: {
                  data1: "#e0aaff",
                  data2: "#c77dff",
                  data3: "#5a189a"
                },
                names: {
                  data1: "Nomina",
                  data2: "Egresos",
                  data3: "Ingresos"
                }
              },

              bar: {
                radius: {
                  ratio: 0.1
                }
              },

              axis: {
                x: {
                  type: "category"
                },
                 y: {
                  label: "Importe"
                },

              },

              

              bindto: this.$refs.chartline1
            });
        },

        


      },

     


    };


</script>
<style scoped>


</style>
